import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'seeMoreButton' })
export class SeeMorePipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {any[]} items
     * @param {string} searchText
     * @returns {any[]}
     */
    transform(text: string, seeMoreButton: boolean = true): string {
        if (seeMoreButton) {
            return text.slice(0,200);
        } else {
            return text;
        }
    }
}
